/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AccountModel from 'cio/models/account';
import { StripeCustomer } from 'cio/utils/billing/stripe-customer';

interface CreditCardDetailsArgs {
  hasCard: boolean;
  account: AccountModel;
  stripeCustomer?: StripeCustomer;
}

// Ember needs to see the full URLs to fingerprint properly, so we cannot
// generate these links dynamically.
const CARD_LOGO_URLS = {
  visa: new URL('cio/assets/images/credit-cards/brand-visa.svg', import.meta.url).toString(),
  amex: new URL('cio/assets/images/credit-cards/brand-amex.svg', import.meta.url).toString(),
  discover: new URL('cio/assets/images/credit-cards/brand-discover.svg', import.meta.url).toString(),
  mastercard: new URL('cio/assets/images/credit-cards/brand-mastercard.svg', import.meta.url).toString(),
};

export default class CreditCardDetails extends Component<CreditCardDetailsArgs> {
  get cardLast4() {
    return this.args.stripeCustomer?.cardLast4 ?? '****';
  }

  get cardExpiry() {
    return this.args.stripeCustomer?.cardExpiry ?? 'XX/XXXX';
  }

  get cardOwnerName() {
    return this.args.hasCard ? this.args.stripeCustomer?.cardOwnerName : 'Jane Doe';
  }

  get cardBrandLogo() {
    let cardType = this.args.stripeCustomer?.cardType;

    if (cardType && ['visa', 'mastercard', 'amex', 'discover'].includes(cardType)) {
      return {
        src: CARD_LOGO_URLS[cardType],
        alt: `Card logo for ${cardType}`,
      };
    }

    return {
      src: new URL('cio/assets/images/credit-cards/brand-unknown.svg', import.meta.url).toString(),
      alt: 'Placeholder for a credit card logo',
    };
  }
}
